import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

//Modules
import { SharedModule } from "../shared/shared.module";
import { NgxPaginationModule } from "ngx-pagination";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatSidenavModule } from '@angular/material/sidenav';
export let options: Partial<IConfig> | (() => Partial<IConfig>);

//Routes
import { PAGES_ROUTING } from "./pages.routing";

//Pipes
import { CustomCurrencyPipe } from '../pipes/custom-currency.pipe';

//Components
import { PagesComponent } from "./pages.component";
import { CreateUserComponent } from "./admin/create-user/create-user.component";
import { HomeComponent } from "./home/home.component";
import { LastRequestsComponent } from "./requests/last-requests/last-requests.component";
import { AdminComponent } from "./admin/admin.component";
import { UserManagementComponent } from "./admin/user-management/user-management.component";
import { CreateSuccessComponent } from "./admin/create-user/create-success.component";
import { EditUserComponent } from "./admin/edit-user/edit-user.component";
import { EditSuccessComponent } from "./admin/edit-user/edit-success.component";
import { ExecutiveComponent } from "./home/executive/executive.component";
import { RequestSearchComponent } from "./requests/request-search/request-search.component";
import { SearchResultComponent } from './requests/request-search/search-result/search-result.component';
import { NewRequestComponent } from './requests/new-request/new-request.component';
import { ConfirmRequestComponent } from './requests/new-request/confirm-request/confirm-request.component';
import { ConfirmRequestSuccessComponent } from './requests/new-request/confirm-request/confirm-request-success.component';
import { RequestDetailComponent } from './requests/request-detail/request-detail.component';
import { ReceiptManagementComponent } from './receipts/receipt-management/receipt-management.component';
import { NewReceiptComponent } from './receipts/new-receipt/new-receipt.component';
import { ReceiptModalComponent } from './receipts/receipt-modal/receipt-modal.component';
import { ReceiptDetailComponent } from './receipts/receipt-detail/receipt-detail.component';
import { EditReceiptComponent } from './receipts/edit-receipt/edit-receipt.component';
import { ReceiptSuccessComponent } from './receipts/receipt-success/receipt-success.component';

@NgModule({
  declarations: [
    PagesComponent,
    CreateUserComponent,
    HomeComponent,
    LastRequestsComponent,
    UserManagementComponent,
    AdminComponent,
    CreateSuccessComponent,
    EditUserComponent,
    EditSuccessComponent,
    ExecutiveComponent,
    RequestSearchComponent,
    SearchResultComponent,
    NewRequestComponent,
    ConfirmRequestComponent,
    ConfirmRequestSuccessComponent,
    RequestDetailComponent,
    ReceiptManagementComponent,
    NewReceiptComponent,
    ReceiptModalComponent,
    ReceiptDetailComponent,
    EditReceiptComponent,
    ReceiptSuccessComponent,
    CustomCurrencyPipe,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    BsDatepickerModule,
    SharedModule,
    PAGES_ROUTING,
    NgxMaskModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxExtendedPdfViewerModule,
    MatSidenavModule
  ],
  providers: []
})
export class PagesModule {}
